/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// const processEnv = typeof process !== 'undefined' ? process.env : {};
var injectedEnv = window && 'injectedEnv' in window ? window.injectedEnv : {};
var env = __assign({}, (typeof injectedEnv === 'object' ? injectedEnv : {}));
env['TOL_DATA'] = env.PORTAL_URL + env.PORTAL_API_PATH;
export { env };
